import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/assets/nami/stickers/no_search_results.png")